export default __webpack_public_path__ + "static/media/player_default.36ac3112.png";